export default __webpack_public_path__ + "static/media/header-img.57846639.png";